import { Object3D } from 'three';

export interface ILayerElement extends Object3D {
  layerElementType: string;
}

export function isLayerElement(object: any): boolean {
  return object['layerElementType'] && object['layerElementType'] === 'ILayerElement';
}
